import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const UnsubscribePage = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = useState(token ? 'working' : 'missing'); // missing | working | done | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.post(`${API_URL}/api/emails/unsubscribe`, { token });
        if (cancelled) return;
        setState('done');
        setMessage(res?.data?.message || "You've been unsubscribed.");
      } catch (err) {
        if (cancelled) return;
        setState('error');
        setMessage(err?.response?.data?.detail || 'Something went wrong. Please try again later.');
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="min-h-screen bg-[#F4F2E9] flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-[#1F3A68] mb-4">Email preferences</h1>

          {state === 'missing' && (
            <p className="text-slate-600">This unsubscribe link is missing its token.</p>
          )}
          {state === 'working' && (
            <p className="text-slate-600">Updating your preferences…</p>
          )}
          {state === 'done' && (
            <>
              <div className="text-emerald-600 text-5xl mb-3">✓</div>
              <p className="text-emerald-800 font-semibold mb-2">{message}</p>
              <p className="text-slate-500 text-sm mb-4">
                You'll still receive essential emails about your account and bookings.
              </p>
              <Link to="/" className="inline-block bg-[#1F3A68] text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-[#1F3A68]/90">Back to Ariv</Link>
            </>
          )}
          {state === 'error' && (
            <>
              <div className="text-red-500 text-5xl mb-3">✕</div>
              <p className="text-red-700 mb-4">{message}</p>
              <Link to="/" className="text-[#1F3A68] font-semibold hover:underline">Back to Ariv</Link>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default UnsubscribePage;
